import { all, race, take, call, put } from "redux-saga/effects"

import {
  CREATE_FOLLOW_RECORD,
  UPDATE_FOLLOW_RECORD,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD,
  LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD,
  FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD,
  ADD_REJECT,
  LOAD_FOLLOWUP_HISTORY,
  LOAD_FOLLOWUP_DETAILS_CRON,
  LOAD_FOLLOWUP_DETAILS,
  LOAD_REJECT_REASON_LIST,
  COMPANY_META_DATA,
} from "./constants"

import {
  createFollowupRecordSuccess,
  createFollowupRecordError,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadRecordsAttachmentDetailDataSuccess,
  loadRecordsAttachmentDetailDataError,
  uploadFollowupAttachmentRecordDataSuccess,
  uploadFollowupAttachmentRecordDataError,
  fileUploadFollowupAttachmentRecordDataSuccess,
  fileUploadFollowupAttachmentRecordDataError,
  addRejectStatusSuccess,
  addRejectStatusError,
  loadRecordsLeadCarryForwardListDataSuccess,
  loadRecordsLeadCarryForwardListDataError,
  loadFollowHistoryDetails,
  loadFollowHistoryDetailsSuccess,
  loadFollowHistoryDetailsError,
  loadFollowCronDetails,
  loadFollowCronDetailsSuccess,
  loadFollowCronDetailsError,
  loadFollowupDetails,
  loadFollowupDetailsSuccess,
  loadFollowupDetailsError,
  loadRejectReasonDetails,
  loadRejectReasonDetailsSuccess,
  loadRejectReasonDetailsError,
  // loadCompanyMetaData,
  loadCompanyMetaDataSuccess,
  loadCompanyMetaDataError,
} from "./actions"

import {
  createFollowupRecord,
  updateFollowupRecord,
  loadRecordsMetaData,
  loadRecordsFollowHistoryRecordData,
  loadRecordsFollowOverallLeadStatusData,
  loadRecordsAttachmentDetailData,
  loadRecordsLeadCarryForwardListData,
  uploadFollowupAttachmentRecordData,
  fileUploadFollowupAttachmentRecordData,
  rejectStatusApi,
  followupHistoryDetails,
  followupCronDetails,
  loadFollowupDetailsList,
  loadRejectReasonList,
  loadCompanyMetaDataDetails,
} from "./remotes"

function* updateFollowupRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_FOLLOW_RECORD),
    })
    const { record } = create || {}

    if (create) {
      try {
        yield call(updateFollowupRecord, record)

        var successVal = createFollowupRecordSuccess(
          record,
          "Followup Details Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          createFollowupRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }

    if (create) {
      console.log("records", record)
      // yield call(setSubmitting, true)
    }
  }
}
// Deliverables section Saga

function* loadFollowupDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadFollowupDetails(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFollowupDetailsList, id)
        console.log(result, "result")
        if (result) {
          yield put(loadFollowupDetailsSuccess(result.data))
        } else {
          yield put(loadFollowupDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadFollowupDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRejectReasonSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_REJECT_REASON_LIST),
    })

    const { explicitLoad } = load

    yield put(loadRejectReasonDetails(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRejectReasonList)

        if (result) {
          yield put(loadRejectReasonDetailsSuccess(result.data))
        } else {
          yield put(loadRejectReasonDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadRejectReasonDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadFollowHistoryDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP_HISTORY),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadFollowHistoryDetails(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(followupHistoryDetails, id)

        if (result) {
          yield put(loadFollowHistoryDetailsSuccess(result.data))
        } else {
          yield put(loadFollowHistoryDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadFollowHistoryDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createFollowupRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_FOLLOW_RECORD),
    })
    const { record } = create || {}

    if (create) {
      try {
        yield call(createFollowupRecord, record)
        var successVal = createFollowupRecordSuccess(
          record,
          "Followup Details Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          createFollowupRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }

    if (create) {
      console.log("records", record)
      // yield call(setSubmitting, true)
    }
  }
}

// Followup cron details saga

function* loadFollowCronDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP_DETAILS_CRON),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadFollowCronDetails(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(followupCronDetails, id)

        if (result) {
          yield put(loadFollowCronDetailsSuccess(result.data))
        } else {
          yield put(loadFollowCronDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadFollowCronDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    const { create } = yield race({
      create: take(LOAD_RECORDS_META_DATA),
    })
    const { leadDetail } = create || {}

    if (leadDetail) {
      try {
        // const followupList = yield call(
        //   loadRecordsMetaData,
        //   "current_followup_list",
        //   "post",
        //   {
        //     leadId: leadDetail.leadId,
        //   }
        // )

        const company = yield call(loadRecordsMetaData, "company", "post", {
          status: "active",
        })

        const department = yield call(
          loadRecordsMetaData,
          "department",
          "post",
          {
            status: "active",
          }
        )

        const team = yield call(loadRecordsMetaData, "team", "post", {
          status: "active",
        })
        const followupStrategy = yield call(
          loadRecordsMetaData,
          "followup_strategy",
          "post"
        )

        const followupMode = yield call(
          loadRecordsMetaData,
          "followup_master",
          "post"
        )

        const followupAction = yield call(
          loadRecordsMetaData,
          "followup_action",
          "post"
        )
        // const reject = yield call(loadRecordsMetaData, "rejectreason", "post")

        const followupHistory = yield call(loadRecordsFollowHistoryRecordData, {
          leadId: leadDetail.leadId,
        })

        const overallLead = yield call(loadRecordsFollowOverallLeadStatusData, {
          leadId: leadDetail.leadId,
          mode: "overallStatusHistory",
        })

        const followupRemarksHistory = yield call(
          loadRecordsFollowOverallLeadStatusData,
          {
            leadId: leadDetail.leadId,
            mode: "followupRemarksHistory",
          }
        )

        let recordsMetaData = {
          // followupList:
          //   followupList && followupList.data && followupList.data.length > 0
          //     ? followupList.data
          //     : [],
          // rejectReasonList:
          //   (reject &&
          //     reject.data &&
          //     reject.data.length > 0 &&
          //     reject.data.map((c) =>
          //       Object.assign({}, { label: c.reason, value: c._id })
          //     )) ||
          //   (reject &&
          //     reject.length > 0 &&
          //     reject.map((c) =>
          //       Object.assign({}, { label: c.reason, value: c._id })
          //     )) ||
          //   [],
          companyList:
            (company &&
              company.data &&
              company.data.length > 0 &&
              company.data.map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
            (company &&
              company.length > 0 &&
              company.map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
            [],
          departmentList:
            (department &&
              department.data &&
              department.data.length > 0 &&
              department.data.map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
            (department &&
              department.length > 0 &&
              department.map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
            [],
          teamList:
            (team &&
              team.data &&
              team.data.length > 0 &&
              team.data.map((c) =>
                Object.assign({}, { label: c.team, value: c._id })
              )) ||
            (team &&
              team.length > 0 &&
              team.map((c) =>
                Object.assign({}, { label: c.team, value: c._id })
              )) ||
            [],
          followupStrategyOptions:
            (followupStrategy &&
              followupStrategy.data &&
              followupStrategy.data.length > 0 &&
              followupStrategy.data
                .filter((_) => _.status === 1)
                .map((e) =>
                  Object.assign(
                    {},
                    {
                      label: `${e.followupStrategy}`,
                      value: e._id,
                    }
                  )
                )) ||
            [],
          followupModeOptions:
            (followupMode &&
              followupMode.data &&
              followupMode.data.length > 0 &&
              followupMode.data
                .filter((_) => _.status === 1)
                .map((e) =>
                  Object.assign(
                    {},
                    {
                      label: `${e.followupMaster}`,
                      value: e._id,
                    }
                  )
                )) ||
            [],
          followupActionOptions:
            (followupAction &&
              followupAction.data &&
              followupAction.data.length > 0 &&
              followupAction.data
                .filter((_) => _.status === 1)
                .map((e) =>
                  Object.assign(
                    {},
                    {
                      label: `${e.followupAction}`,
                      value: e._id,
                    }
                  )
                )) ||
            [],
          followupHistoryList:
            followupHistory &&
            followupHistory.data &&
            followupHistory.data.length > 0
              ? followupHistory.data
              : [],
          overallLeadList:
            overallLead && overallLead.data && overallLead.data.length > 0
              ? overallLead.data
              : [],

          followupRemarksHistoryList:
            followupRemarksHistory &&
            followupRemarksHistory.data &&
            followupRemarksHistory.data.length > 0
              ? followupRemarksHistory.data
              : [],
        }
        yield put(loadRecordsMetaDataSuccess(recordsMetaData))
      } catch (error) {
        yield put(
          loadRecordsMetaDataError(
            (error && error.response && error.response.message) ||
              "Fetch Dropdown Records Failed"
          )
        )
      }
    }
  }
}
function* loadCompanyMetaDataSaga() {
  while (true) {
    yield race({
      metaData: take(COMPANY_META_DATA),
    })

    try {
      const company = yield call(loadCompanyMetaDataDetails, "all_cross_promotion_company", "post")
      const subStatus = yield call(loadCompanyMetaDataDetails,"lead_substatus","post")
      let recordsMetaData = {
        companyList:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status == 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          [],
        subStatusOptions: (subStatus &&
          subStatus.data &&
          subStatus.data.length > 0 &&
          subStatus.data
            .filter((_) => _.status == 1)
            .map((c) =>
              Object.assign({}, { label: c.leadSubSourceName, value: c.leadSubSourceName,companyId:c.companyId})
            )) ||
        [],
      }
      yield put(loadCompanyMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadCompanyMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* loadRecordsAttachmentDetailDataSaga() {
  while (true) {
    yield race({
      create: take(LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD),
    })
    try {
      const attachmentData = yield call(loadRecordsAttachmentDetailData)
      let recordsAttachmentData =
        attachmentData && attachmentData.data && attachmentData.data.length > 0
          ? attachmentData.data
          : []
      yield put(loadRecordsAttachmentDetailDataSuccess(recordsAttachmentData))
    } catch (error) {
      yield put(
        loadRecordsAttachmentDetailDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* loadRecordsLeadCarryForwardListDataSaga() {
  while (true) {
    const { create } = yield race({
      create: take(LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD),
    })
    const { leadCarryForwardDetail } = create || {}

    try {
      const carryFordwardData = yield call(
        loadRecordsLeadCarryForwardListData,
        leadCarryForwardDetail
      )

      let recordsCarryFordwardData =
        carryFordwardData &&
        carryFordwardData.data &&
        carryFordwardData.data.length > 0
          ? carryFordwardData.data[0]
          : []
      yield put(
        loadRecordsLeadCarryForwardListDataSuccess(recordsCarryFordwardData)
      )
    } catch (error) {
      yield put(
        loadRecordsLeadCarryForwardListDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* uploadFollowupAttachmentRecordDataSaga() {
  while (true) {
    const { create } = yield race({
      create: take(UPLOAD_FOLLOW_ATTACHMENT_RECORD),
    })

    const { uploadRecord } = create || {}

    if (create) {
      try {
        const attachmentData = yield call(
          uploadFollowupAttachmentRecordData,
          uploadRecord
        )
        let recordsAttachmentData =
          attachmentData &&
          attachmentData.data &&
          attachmentData.data.length > 0
            ? attachmentData.data
            : []
        yield put(
          uploadFollowupAttachmentRecordDataSuccess(recordsAttachmentData)
        )
      } catch (error) {
        yield put(
          uploadFollowupAttachmentRecordDataError(
            (error && error.response && error.response.message) ||
              "Fetch Dropdown Records Failed"
          )
        )
      }
    }
  }
}

function* fileUploadFollowupAttachmentRecordDataSaga() {
  while (true) {
    const { create } = yield race({
      create: take(FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD),
    })

    const { fileUploadRecord } = create || {}

    if (create) {
      try {
        const attachmentData = yield call(
          fileUploadFollowupAttachmentRecordData,
          fileUploadRecord
        )
        let recordsAttachmentData =
          attachmentData &&
          attachmentData.data &&
          attachmentData.data.length > 0
            ? attachmentData.data
            : []
        yield put(
          fileUploadFollowupAttachmentRecordDataSuccess(recordsAttachmentData)
        )
      } catch (error) {
        yield put(
          fileUploadFollowupAttachmentRecordDataError(
            (error && error.response && error.response.message) ||
              "Fetch Dropdown Records Failed"
          )
        )
      }
    }
  }
}
//ADD REJECT
function* addRejectSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(ADD_REJECT),
    })

    const { explicitLoad } = load

    const { reject_Status } = explicitLoad || {}
    yield put(explicitLoad) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(rejectStatusApi, reject_Status)

        if (result) {
          yield put(addRejectStatusSuccess(result.Data))
        } else {
          yield put(addRejectStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          addRejectStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    createFollowupRecordSaga(),
    updateFollowupRecordSaga(),
    loadCompanyMetaDataSaga(),
    loadRecordsMetaDataSaga(),
    loadRecordsAttachmentDetailDataSaga(),
    uploadFollowupAttachmentRecordDataSaga(),
    fileUploadFollowupAttachmentRecordDataSaga(),
    addRejectSaga(),
    loadRecordsLeadCarryForwardListDataSaga(),
    loadFollowHistoryDetailsSaga(),
    loadFollowCronDetailsSaga(),
    loadFollowupDetailsSaga(),
    loadRejectReasonSaga(),
  ])
}
